import { IconButton, Stack,TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import RowBadge from "./Badge/RowBadge";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import studylistContext from "../../../context/studylist/StudylistContext";
import { CUSTOM_STYLES, HIDE_ALERT_RAISE, ORDER_ID_COLORS, REINFERECE_ALLOWED_MODALITY, REPORTDONESTATUS, REPORT_DONE_STATUS, REPORTED_TABS_NAME, RESTRICTED_STORAGE_TYPES, SHOW_RETURNED_ROLES, TAB_NAME, USERTYPES, modalityRowBadgeColor, widthOfColumns, TOAST_TYPE } from "../../../constants/Constants";
import userContext from "../../../context/users/UserContext";
import { ClosePaneIcon } from "@fluentui/react-icons-mdl2";
import InfoIcon from "../../../components/SVGComponents/InfoIcon";
import ErrorIcon from "../../../components/SVGComponents/ErrorIcon";
import { t } from "i18next";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import { capitalizeFullName } from "../helpers/helpingFunctions";
import themeContext from "../../../context/theme/ThemeContext";
import { toolTipStyles } from "../../StudyViewer/styles/styles";
import axios from "axios";
import PlatformHelper from "../../../helpers/PlatformHelper";
import { use } from "react";
import { getEnv } from '../../../helpers/EnvHelper';
import toastContext from "../../../context/toast/ToastContext";

const studyDetailsContainer = {
  display: "flex",
  flex: "1",
  position: "relative",
  cursor: "pointer", 
};

const patientAgeChatContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "5px"
};
const patientAgeContainer = {
  display: "flex",
  flex: "0.5",
  paddingRight:"25px",
  cursor: 'text'
};


const PatientDetails = (props) => {

  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;

  const {
    setShowCommunicationModal,
    showReturnedStudyReasonModal,
    setShowReturnedStudyReasonModal,
    rowSelectedArray,
    trackOfVisisted, setTrackOfVisited,
    filterInputValues,
    isTypistWorkflowEnabled,
  } = useContext(studylistContext);

  const {roles,userId,username, name} = useContext(userContext);
  const { themeName, getThemeColor } = useContext(themeContext);
  const { showToastv2 } = useContext(toastContext);
  const [copiedTooltipKey, setCopiedTooltipKey] = useState("");

  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;

  const extractCorrectAge = (str) => {
    if (str[str.length - 1] == "Y" && str[0] == "0") {
      return str.substring(1, str.length - 1);
    }
    return str;
  };




  const badgeStyle = {
    marginLeft: "2px",
    backgroundColor: "#BBDEFF",
    height: "18px",
    fontSize: "10px",
    color: "#0035BE",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    fontFamily: "Open Sans",
    fontWeight: "700",
    padding: "0px 5px",
    borderRadius: "10px",
    lineHeight: "16px",
    gap: "10px",
  };


  const getTrackedOfVisited = (study) => {
    return trackOfVisisted.includes(study.id);
  }

  const checkIfCannotDelete = (study) => {
    if((study.assignmentList[0].clientId == 0 && (study.reportDoneStatus > 0 || study.assignmentList[0].providerId != null)) &&
    study.assignmentList[0].firmName != 'firsthospital'
    ){
      return true;
    }else if(((study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null)
    ||  study.assignmentList[0].firmName == 'firsthospital'
    ){
      return false;
    }else{
      return true;
    }
  }

  const checkIfCannotDeleteImages = (study) => {
    // console.log(study);
    if((study.assignmentList[0].clientId == 0 && (study.reportDoneStatus > 0 || study.assignmentList[0].providerId != null)) &&
    study.assignmentList[0].firmName != 'firsthospital'
    ){
     
        return false;
    }else if(((study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null)
    ||  study.assignmentList[0].firmName == 'firsthospital'
    ){
      if(study.clientBillingStudy && study.noOfImages > 0)
        return true;
      else
        return false;
    }else{
        return false;
    }
  }

  const checkIfCannotReinference = (study) => {
    if(((REINFERECE_ALLOWED_MODALITY.includes(study.modality.name) && study.triageXRAYStudies) || study.aiReinference) && study.reportDoneStatus != 2 && !study.genkiStudy){
      return true;
    }else{
      return false;
    }
  }

  const getAccessionNumber = ()=>{
    return filterInputValues?.showAccessionNumber ? ' | ' +props.data.row.original.accessionNumber: '';
  }

  const customPatientColumnTooltip = {
    root: "study-list-patientDetails-name study-list-min-width",
  }

  const customPatientIdTooltip = {
    root: "study-list-patientDetails-id-txt"
  }
  const customOrderIdTooltip={
    root:getEnv("REACT_APP_VDC_PLATFORM") == "true" ?"":"study-list-patientDetails-id-txt"
  }

  const checkForAnyTopTagExist = () => {
    if((props.data.row.original.edited &&
      props.data.row.original.reportDoneStatus <= 2)
      || ((props.data.row.original.visited != null && props.data.row.original.visited != undefined &&
        props.data.row.original.visited) || getTrackedOfVisited(props.data.row.original))
      ||
      (props.data.row.original.assignmentList[0].reportDoneStatus ===
        REPORT_DONE_STATUS.REPORTED && props.data.row.original.raiseAlertAttention && props.data.row.original.raiseAlert != "")
      ||
      props.data.row.original.assignmentList[0]?.priority == true
      ||
      (roles.length > 0 && SHOW_RETURNED_ROLES.includes(roles[0]) && props.data.row.original.unassignedReasonCount > 0)
      ){
        return true;
      }
      return false;
  }

  const mainStackStyles = {
    justifyContent: "center",
    marginTop: checkForAnyTopTagExist()? CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN : CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
    paddingLeft: props.data.row.depth === 0 ? "unset" : "20px",
    ...(props.data.row.depth !== 0 && { position: "relative" }),
  };

  const checkAndGetAccessCode = ()=>{
    if(  props.data.row.original.assignmentList[0]?.studyAccessCode == null || props.data.row.original.assignmentList[0]?.studyAccessCode === undefined  ){
      
      return false;
    }else{
      if(props.data.row.original.assignmentList[0]?.providerId==  "R" + userId && props.data.row.original.reportDoneStatus  < 2 ) 
        return true;
      else{
        return false;
      }
    }
  }
  const priorMismatchToolTip={
    calloutProps: {
      styles: {
        beak: { background: getThemeColor("tooltip") },
        beakCurtain: { background: getThemeColor("tooltip") },
        calloutMain: { background:getThemeColor("tooltip"), height:"75px",width:"160px"},
        borderRadius: "5px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      },
    },
  }

  const copyTooltipProps = {
    calloutProps: {
      isBeakVisible: false,
      gapSpace: 0,
      styles: {
        calloutMain: {
          background: getThemeColor("tooltip") || getThemeColor("hide-tooltip-border"),
          borderRadius: "4px",
          boxShadow: "none",
        },
      },
    },
    styles: {
      root: {
        background: getThemeColor("tooltip") || getThemeColor("hide-tooltip-border"),
        boxShadow: "none",
      },
      content: { color: getThemeColor("primary-color") },
    },
  };
  const copyTooltipHostProps = { tooltipProps: copyTooltipProps, closeDelay: 500 };

  const checkAndGetAssignedTypist = ()=>{
    if(  props.data.row.original.typistId == null || props.data.row.original.typistId === 0  ){
      
      return false;
    }else{
      if(props.data.row.original.typistId === userId) 
        return true;
      else{
        return false;
      }
    }
  }

  const hasValidOrderId = (orderId) => { return orderId !== null && orderId !== undefined &&  orderId !== '' &&  orderId !== '-'; };

  const getOrderColor = (orderId) => {
    if (!orderId) return null;
  
    let hash = 0;
    for (let i = 0; i < orderId.length; i++) {
      hash = orderId.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    return ORDER_ID_COLORS[Math.abs(hash) % ORDER_ID_COLORS.length];
  };

  const copyToClipboard = async (value, key, event,label) => {
    event?.preventDefault();
    event?.stopPropagation();

    const textToCopy = value != null ? `${value}` : "";

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(textToCopy);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.setAttribute("readonly", "");
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }

      setCopiedTooltipKey(key);
      setTimeout(() => setCopiedTooltipKey(""), 1500);
      showToastv2(TOAST_TYPE.SUCCESS, label+" copied");  
    } catch (error) {
      console.error("Clipboard error:", error);
    }
  };

  const getCopyTooltipContent = (label, value, key) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        maxWidth: "260px",
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <span style={{ overflowWrap: "anywhere" }}>{`${label} : ${value ?? ""}`}</span>
      <IconButton
        iconProps={{
          iconName: copiedTooltipKey === key ? "CheckMark" : "Copy",
          styles: { root: { color: copiedTooltipKey === key ? "#92C353" : "inherit" } },
        }}
        ariaLabel={copiedTooltipKey === key ? "Copied" : `Copy ${label}`}
        title={copiedTooltipKey === key ? "Copied" : `Copy ${label}`}
        onClick={(event) => copyToClipboard(value, key, event,label)}
        styles={{
        root: {
          width: "20px",
          height: "20px",
          minWidth: "20px",
          padding: 0,
          color: "inherit",
          backgroundColor: "transparent",
        },
        rootHovered: {
          backgroundColor: "transparent",
          color: "inherit",
        },
        rootPressed: {
          backgroundColor: "transparent",
          color: "inherit",
        },
        rootFocused: {
          backgroundColor: "transparent",
        },
        icon: {
          fontSize: "12px",
          color: copiedTooltipKey === key ? "#92C353" : "inherit",
        },
      }}
      />
    </div>
  );

  return (
    <>
      <Stack style={{ ...mainStackStyles }} data-tut={`tour-patient-details`}>

        <div style={studyDetailsContainer}>
        <CustomToolTipHost  
          styles={{ height: "24px",display: "flex",alignItems: "center"}} 
          toolTipProps={priorMismatchToolTip} 
          content={t("study-list.messages.prior-mismatch")}
          >{roles[0] !== USERTYPES.TYPIST && props.data.row.depth === 0 && props.data.row.original.priorMismatch  && <ErrorIcon></ErrorIcon>}
        </CustomToolTipHost>
        {roles[0] !== USERTYPES.TYPIST && props.data.row.depth === 0 && props.data.row.original.priorMismatch && <div style={{width:'5px'}}></div>}
        <TooltipHost styles={customPatientColumnTooltip} content={getCopyTooltipContent(t("patient.name"), capitalizeFullName(props.data.row.original.patientName), "patientName")} id={"tooltip_"} {...copyTooltipHostProps}>
              {capitalizeFullName(props.data.row.original.patientName)}
          </TooltipHost>
          </div>
            <span className="study-list-patientDetails-id">
              {getEnv("REACT_APP_VDC_PLATFORM") == "true" && props.data.row.depth === 0 && 
              <div style={{display:"flex", flexDirection:"column"}}>
                {(roles[0].includes(USERTYPES.RADIOLOGIST) && hasValidOrderId(props.data.row.original.orderId)) ? 
                  <div style={{display:'flex',alignItems:'center'}}>
                    <RowBadge
                      customClassName = "study-list-modality-badge"
                      tooltipText={getCopyTooltipContent("Order Id", props.data.row.original.orderId, "orderId")}
                      name={`O : ${props.data.row.original.orderId}`}
                      colorObj={getOrderColor(
                        props.data.row.original.orderId
                      )}
                      isQueueBadge={true}
                      toolTipProps={copyTooltipProps}
                      closeDelay={copyTooltipHostProps.closeDelay}
                    />
                  </div> :
                <TooltipHost styles={customOrderIdTooltip} content={getCopyTooltipContent("Order Id", props.data.row.original.orderId, "orderId")} id={"tooltip_"} {...copyTooltipHostProps}>O:{`${props.data.row.original.orderId}`}</TooltipHost> }
                <TooltipHost styles={customOrderIdTooltip} content={getCopyTooltipContent("Accession Number", props.data.row.original.accessionNumber, "accessionNumber")} id={"tooltip_"} {...copyTooltipHostProps}>A:{`${props.data.row.original.accessionNumber}`}</TooltipHost>
                <TooltipHost styles={customOrderIdTooltip} content={getCopyTooltipContent("Patient Id", props.data.row.original.patientId, "patientId")} id={"tooltip_"} {...copyTooltipHostProps}>P:{`${props.data.row.original.patientId}`}</TooltipHost>
              </div>}
              {getEnv("REACT_APP_VDC_PLATFORM") == "false" && props.data.row.depth === 0 && 
              <div style={{display:"flex", flexDirection:"column"}}>
                <TooltipHost styles={customPatientIdTooltip} content={getCopyTooltipContent("Patient Id", props.data.row.original.patientId, "patientId")} id={"tooltip_"} {...copyTooltipHostProps}>P:{`${props.data.row.original.patientId}`}</TooltipHost>
                <TooltipHost styles={customPatientIdTooltip} content={getCopyTooltipContent("Accession Number", props.data.row.original.accessionNumber, "accessionNumber")} id={"tooltip_"} {...copyTooltipHostProps}>A:{`${props.data.row.original.accessionNumber}`}</TooltipHost>
              </div>
                // <CustomToolTipHost styles={customPatientIdTooltip} content={`${t("error-study-list.id").toUpperCase()} : ${props.data.row.original.patientId} ${getAccessionNumber()}`} id={"tooltip_"}>
                // {`${props.data.row.original.patientId}`}{" "} {getAccessionNumber()}
                // </CustomToolTipHost>
              }
            </span>
            {/* <RowBadge name={props.data.row.original.modality.name} colorObj={modalityRowBadgeColor(props.data.row.original.modality.name)} /> */}
            <span className="study-list-top-badge-container"
              style={props.data.row.depth !== 0 ? { left: "4px", top: "-16px" } : {}}
              >

            {/* Batch Action Buttons - Updated Logic */}
            {props.data.row.depth == 0 && rowSelectedArray.includes(props.data.row.index) && (
              <>
                {/* Delete Button - Show only for NON-REPORTED tabs */}
                {!REPORTED_TABS_NAME.includes(props.tabId) && (
                  checkIfCannotDelete(props.data.row.original) ? (
                    <CustomToolTipHost content={t("study-list.messages.cannot-batch-delete")} id={"tooltip_"}>
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "white", background: "red", alignItems: 'center', whiteSpace: 'nowrap' }}
                      >
                        {t("study-list.actions.delete-study")}
                      </span>
                    </CustomToolTipHost>
                  ) : (
                    <CustomToolTipHost content={t("study-list.messages.added-batch-delete")} id={"tooltip_"}>
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "white", background: "green", alignItems: 'center', whiteSpace: 'nowrap' }}
                      >
                        {t("study-list.actions.delete-study")}
                      </span>
                    </CustomToolTipHost>
                  )
                )}

                {/* Delete Images Button - Show only for NON-REPORTED tabs */}
                {!REPORTED_TABS_NAME.includes(props.tabId) && checkIfCannotDeleteImages(props.data.row.original) && (
                  <CustomToolTipHost content={t("study-list.messages.added-batch-delete-image")} id={"tooltip_"}>
                    <span
                      className="study-list-top-badge-item"
                      style={{ color: "white", background: "green", alignItems: 'center', whiteSpace: 'nowrap' }}
                    >
                      {t("study-list.actions.delete-image")}
                    </span>
                  </CustomToolTipHost>
                )}

                {/* AI Reinference Button - Show only for NON-REPORTED tabs */}
                {!REPORTED_TABS_NAME.includes(props.tabId) && (
                  !checkIfCannotReinference(props.data.row.original) ? (
                    <CustomToolTipHost content={t("study-list.messages.cannot-batch-reinference")} id={"tooltip_"}>
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "white", background: "red", alignItems: 'center', whiteSpace: 'nowrap' }}
                      >
                        {t("study-list.actions.reinference")}
                      </span>
                    </CustomToolTipHost>
                  ) : (
                    <CustomToolTipHost content={t("study-list.messages.added-batch-reinference")} id={"tooltip_"}>
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "white", background: "green", alignItems: 'center', whiteSpace: 'nowrap' }}
                      >
                        {t("study-list.actions.reinference")}
                      </span>
                    </CustomToolTipHost>
                  )
                )}

                {/* Download Button - Show only for REPORTED tab */}
                {REPORTED_TABS_NAME.includes(props.tabId) && (
                  <CustomToolTipHost content={t("study-list.actions.download-study") || "Download Report"} id={"tooltip_"}>
                    <span
                      className="study-list-top-badge-item"
                      style={{ color: "white", background: "green", alignItems: 'center', whiteSpace: 'nowrap', cursor: 'pointer' }}
                    >
                      {t("study-list.actions.download-study") || "Download"}
                    </span>
                  </CustomToolTipHost>
                )}
              </>
            )}

              {(roles[0] !== USERTYPES.RADIOLOGIST && props.data.row.depth === 0 && props.data.row.original.clientBillingStudy) && (
                  <CustomToolTipHost content={t("study-list.messages.order-study-tooltip")} id={"tooltip_"}>
                    <span
                      className="study-list-top-badge-item"
                      style={{ color: "#312404", background: "#c6b1e6" }}
                    >
                      {t("study-list.badges.order-study").toUpperCase()}
                    </span>
                  </CustomToolTipHost>
                )}
              {(isBvpPlatform && props.data.row.original.reviewPending && props.data.row.original.reportDoneStatus == 1) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: "#f5942d" }}
                  >
                    {t("study-list.badges.review-pending").toUpperCase()}
                  </span>
                )}
              {(props.data.row.original.edited &&
                props.data.row.original.reportDoneStatus <= 2) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: " #f5bd2d" }}
                  >
                    {t("study-list.badges.edited").toUpperCase()}
                  </span>
                )}
                {((props.data.row.original.visited != null && props.data.row.original.visited != undefined &&
                props.data.row.original.visited) || getTrackedOfVisited(props.data.row.original)) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: "rgb(223 173 173)" }}
                  >
                    {t("study-list.badges.visited").toUpperCase()}
                  </span>
                )}
                {
                props.data.row.original.assignmentList[0]?.priority == true && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: "#4df53d" }}
                  >
                    {t("study-list.badges.new").toUpperCase()}
                  </span>
                )}
                {(props.data.row.original.storageType === 2 || props.data.row.original.storageType === 3) && (
                  <CustomToolTipHost content={props.data.row.original.storageType === 2 ? "ARCHIVED" : "AVAILABLE: " + props.data.row.original.daysLeftForExpiry + " Days Left"} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{  whiteSpace:"nowrap", color: "#312404", background: props.data.row.original.storageType === 2 ? "#c1c1c1" : "rgb(51 222 247)", }}
                  >
                    {props.data.row.original.storageType === 2 ? "ARCHIVED" : "AVAILABLE: " + props.data.row.original.daysLeftForExpiry + "D"}
                  </span> </CustomToolTipHost>
                )}
                {isBucketManagement && RESTRICTED_STORAGE_TYPES.includes(props.data.row.original.storageType) && (
                  <CustomToolTipHost content={t("study-list.badges.deleted").toUpperCase()} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{  whiteSpace:"nowrap", color: "#rgb(255, 255, 255)", background:  "rgb(225 79 46)", }}
                  >
                    {t("study-list.badges.deleted").toUpperCase()}
                  </span> </CustomToolTipHost>
                )}
              {/* {roles.length > 0 && SHOW_RETURNED_ROLES.includes(roles[0]) && getReturnedStudyCount(props.data.row.original.id) != null && (
                <span
                  onClick={() => {
                    setShowReturnedStudyReasonModal({
                      studyId: props.data.row.original.id,
                      show: true,
                    });
                  }}
                  className="study-list-top-badge-item"
                  style={{ color: "rgb(3 52 98)", background: "#59ADFA",whiteSpace:"nowrap" }}
                >{`${t("study-list.badges.returned").toUpperCase()} ${props.data.row.original.unassignedReasonCount}`}  </span>
              )} */}

              {/*Study access code*/}
              {roles.length > 0 && roles[0].includes(USERTYPES.RADIOLOGIST) && (isTypistWorkflowEnabled==1) && checkAndGetAccessCode()  && (
                <span
                  
                  className="study-list-top-badge-item"
                  style={{ color: themeName === "light"?"white":"rgb(3 52 98)", background: "grey" , whiteSpace:"nowrap", fontFamily:"Consolas", fontSize:"11px"}}
                >{`${t("study-list.badges.access-code").toUpperCase()} ${
                  props.data.row.original.assignmentList[0]?.studyAccessCode
                }`}</span>
              )}

              {/*Study assigned to typist*/}
              {roles.length > 0 && roles[0].includes(USERTYPES.TYPIST) && checkAndGetAssignedTypist()  && (
                <span
                  
                  className="study-list-top-badge-item"
                  style={{ color: themeName === "light"?"white":"rgb(3 52 98)", background: "grey" , whiteSpace:"nowrap"}}
                >{` ${
                  name
                }`}</span>
              )}

    

              {(PlatformHelper.isFahes() && props.data.row.original.reportDoneStatus == 2) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{  whiteSpace:"nowrap", color: "#312404", background: props.data.row.original.storageType === 2 ? "#c1c1c1" : "rgb(51 222 247)", }}
                  >
                    {props.data.row.original.positive === true ? "TB POSITIVE" : "TB NEGATIVE"}
                  </span>
                )}



              {(roles.length > 0 && !HIDE_ALERT_RAISE.includes(roles[0]) && (props.data.row.original.assignmentList[0].reportDoneStatus ===
            REPORT_DONE_STATUS.REPORTED || props.data.row.original.assignmentList[0].reportDoneStatus === REPORT_DONE_STATUS.SAVED) && props.data.row.original.raiseAlertAttention && props.data.row.original.raiseAlert != "" && !(props.data.row.original.peerReviewAssignment?.reviewerId == userId && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE))) &&
                  <div style={{ display: "flex" }}>
                    <CustomToolTipHost
                      //styles={customToolTipRaiseAlertStyles}
                      content={`${t("study-list.badges.raise-alert")}: `+props.data.row.original.raiseAlert}
                      id={"tooltip_"}
                    >
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "rgb(55 38 6)", background: "rgb(245 173 41 / 69%)",whiteSpace:'nowrap'  }}
                      >
                        {t("study-list.badges.raise-alert").toUpperCase()}
                      </span>
                    </CustomToolTipHost>
                  </div>}
                {(roles.length > 0  && props.data.row.original.originalFirm!=null) &&
                  <div style={{ display: "flex" }}>
                    <CustomToolTipHost
                      //styles={customToolTipRaiseAlertStyles}
                      content={`${t("study-list.badges.original-center")}: `+props.data.row.original.originalFirm}
                      id={"tooltip_"}
                    >
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "rgb(55 38 6)", background: "rgb(245 173 41 / 69%)",whiteSpace:'nowrap'  }}
                      >
                        {t("study-list.badges.changed-center").toUpperCase()}
                      </span>
                    </CustomToolTipHost>
                  </div>}
            </span>
          
        <div style={patientAgeChatContainer}>
          <div style={patientAgeContainer}>
          <CustomToolTipHost
                      //styles={customToolTipRaiseAlertStyles}
                      content={`Gender: ${props.data.row.original.patientSex} & Age: ${props.data.row.original.patientAge == 0
                        ? props.data.row.original.patientAge.substring(1)
                        : extractCorrectAge(props.data.row.original.patientAge)}`}
                      id={"tooltip_"}
                    >
            <span className="study-list-patient-age">
              {props.data.row.original.patientSex}
            </span>
            <span className="study-list-patient-age-separator" style={{ marginLeft: "4px", marginRight: "4px" }}>|</span>
            <span className="study-list-patient-age">
              {props.data.row.original.patientAge == 0
                ? props.data.row.original.patientAge.substring(1)
                : extractCorrectAge(props.data.row.original.patientAge)}
            </span>
            </CustomToolTipHost>
          </div>
        </div>
      </Stack>
    </>
  );
};

export default PatientDetails;


